import React from 'react';
import Immutable from 'immutable';

import {
  SliderRelated,
  useWindowDimensions,
} from '@uncinc/uncinc-react-kitchen-sink';
import { Node } from '@uncinc/react-drupal-core';
import { ImmutableEntity } from '@uncinc/react-drupal-core/types';

import {
  SCREEN_HUGE, SCREEN_NORMAL, SCREEN_TABLET,
} from '../../../config/constants';

import { NodeArticle } from '../../../types/uncinc_profile/nodes';

import './style.scss';

interface ViewArticleHighlightsProps {
  entities: Immutable.List<ImmutableEntity<NodeArticle>>;
}

const ViewArticleHighlights: React.FC<ViewArticleHighlightsProps> = ({ entities }) => {
  const defaultProps = {
    autoplay: false,
  };
  const { width } = useWindowDimensions();
  let slidesToShow = 1.1;
  if (width > SCREEN_TABLET) {
    slidesToShow = 2.2;
  }
  if (width > SCREEN_NORMAL) {
    slidesToShow = 3.2;
  }
  if (width > SCREEN_HUGE) {
    slidesToShow = 4;
  }

  return (
    <div className="ArticleHighlights">
      <SliderRelated
        {...defaultProps}
        slidesToShow={slidesToShow}
        infinite={false}
        centerMode={false}
      >
        {
          entities.map((entity) => {
            const id = entity.getIn(['nid', 0, 'value']);
            const uuid = entity.getIn(['uuid', 0, 'value']);
            const langcode = entity.getIn(['langcode', 0, 'value']);
            const key = `${uuid}:${langcode}`;

            return (
              <Node
                key={key}
                id={id}
                entity={entity}
                viewMode="teaser"
                classes="ArticleTeaser--slide"
              />
            );
          })
        }
      </SliderRelated>
    </div>
  );
};

export default ViewArticleHighlights;
